// extracted by mini-css-extract-plugin
module.exports = {"contentTypes":"content-types_contentTypes__2Ofgh","list":"content-types_list__2I0Nh","contentType":"content-types_contentType__127a2"};